// extracted by mini-css-extract-plugin
export var addButton = "_56-d";
export var bullets = "_56-e";
export var compact = "_56-2";
export var container = "_56-j";
export var extendedWarrantyModal = "_56-f";
export var learn = "_56-l";
export var learnMore = "_56-g";
export var offeringOption = "_56-3";
export var offeringPrice = "_56-8";
export var offeringSubtitle = "_56-7";
export var offeringTitle = "_56-6";
export var offeringsContainer = "_56-0";
export var pdpTilesBackground = "_56-n";
export var plan = "_56-m";
export var regular = "_56-1";
export var remove = "_56-k";
export var seeDetailsIcon = "_56-i";
export var seeDetailsLink = "_56-h";
export var selectedOption = "_56-4";
export var shieldIcon = "_56-b";
export var shieldIconCompact = "_56-c";
export var subtitle = "_56-a";
export var title = "_56-9";
export var unselectedOption = "_56-5";